<template lang="html">
  <div id="image-viewer-popup" @click="closeDialog">
    <div class="content">
      <div id="close-btn">x</div>
      <img :src="imageUrl" alt="csepel-foto">
    </div>
  </div>
</template>

<script>
export default {
  name: 'imageViewerPopup',
  props: ['selectedImage'],
  computed: {
    imageUrl () {
      return this.$store.getters['config/getImageUrls']({name: this.selectedImage, width:this.width, folder:'csepel/fotos'}).retina
    },
    width () {
      return Math.round(window.innerWidth * 0.9);
    }
  },
  methods: {
    closeDialog (e) {
      if (e.target.id === 'image-viewer-popup' || e.target.id === 'close-btn') this.$emit('close')
    }
  }
}
</script>

<style scoped>
  #image-viewer-popup {
    position: fixed;
    background-color: rgba(40, 70, 120, 0.9);
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    height: 100%;
  }
  #close-btn {
    position: absolute;
    top: 0;
    right: 0;
    color: white;
    font-weight: bold;
    cursor: pointer;
    width: 25px;
    height: 25px;
    font-size: 1.3em;
  }
  .content {
    position: absolute;
    border: 5px solid white;
    /* border: 5px solid rgba(224, 102, 103, 1); */
    border-radius: 2px;
    left: 5vw;
    top: 5vh;
    height: 90vh;
    width: 90vw;
    text-align: center;
    background-color: white;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
